module.exports = __webpack_public_path__ + "static/img/3A.5cc6da0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/innovation/3A.jpeg
// module id = 2z14
// module chunks = 2